import { render, staticRenderFns } from "./HousingOptionsDetailView.vue?vue&type=template&id=281a795c"
import script from "./HousingOptionsDetailView.vue?vue&type=script&lang=js"
export * from "./HousingOptionsDetailView.vue?vue&type=script&lang=js"
import style0 from "./HousingOptionsDetailView.vue?vue&type=style&index=0&id=281a795c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports